import React, { Component } from 'react';
import { ContactsTable } from './Contacts/ContactsTable';

export class Contacts extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <h1>Contacts</h1>
                <hr />
                <ContactsTable />
            </div>
        );
    }
}